import './style.scss';
import React from 'react';
import clsx from 'clsx';
import Button from '../../Shared/components/controls/Button';
import { Image, RichText, Text } from '@sitecore-jss/sitecore-jss-react';

const FAQCards = (props) => {
  const listLength = props.List.length || 0;
  const shouldRenderList = Array.isArray(props.List) && listLength > 0;

  if (!shouldRenderList) return null;
  return (
    <div
      className={clsx(
        'faq-cards flex-it',
        listLength === 1 ? 'one-item' : '',
        listLength === 2 ? 'two-item' : ''
      )}
    >
      {shouldRenderList &&
        props.List?.map((item, index) => {
          const _link = item?.fields?.link;
          const _text = item?.fields?.text;
          const _heading = item?.fields?.heading;
          const _image = item?.fields?.image;
          const shouldRenderTitle = !!_heading?.value;
          const shouldRenderImage = !!_image?.value?.src;
          const shouldRenderDescription = !!_text?.value;
          const shouldRenderLink = !!_link?.value?.href;

          return (
            <div className="faq-card" key={index}>
              <div className="auto">
                {shouldRenderImage && (
                  <div className="faq-card-image">
                    <Image field={_image} />
                  </div>
                )}

                {(shouldRenderTitle || shouldRenderDescription || shouldRenderLink) && (
                  <div className="faq-wrap-text-link">
                    {shouldRenderTitle && (
                      <div className="faq-card-title">
                        <Text field={_heading} />
                      </div>
                    )}
                    {shouldRenderDescription && (
                      <RichText className="faq-card-description" field={_text} />
                    )}
                    {shouldRenderLink && <Button className="btn-faq-card" link={_link} />}
                  </div>
                )}
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default FAQCards;
